<template>
  <section v-if="dyanmicCommentContents.length" class="w-full">
    <div v-if="divider" class="mb-4 mt-6 h-2 w-full bg-[#f5f5f5]"></div>
    <comment-item
      v-for="item in dyanmicCommentContents"
      :key="item.uuid"
      :comment="item"
    ></comment-item>
  </section>
</template>

<script setup lang="ts">
defineOptions({ name: 'CommentList' });

const dyanmicCommentContents = inject<Ref<Dynamic.DynamicCommentContent[]>>(
  'dyanmicCommentContents',
  ref([]),
);

withDefaults(defineProps<{ divider?: boolean }>(), {
  divider: true,
});
</script>
